import { Flooding } from 'features/flooding/flooding.types';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { GeoEventFormStatus } from 'shared/types';
import { statusToTransKey } from './useGeoEventStatusFormFieldChanges.utils';

type UseGeoEventStatusFormFieldChangesProps = {
  geoEvent: Wildfire | Flooding;
};

type FormValues = {
  status: 'active' | 'inactive';
};

type ChangeKey = 'status';

type ChangeMap = Partial<Record<ChangeKey, string>>;

export const useGeoEventStatusFormFieldChanges = (
  props: UseGeoEventStatusFormFieldChangesProps,
): ChangeMap => {
  const { geoEvent } = props;
  const { t } = useTranslation();

  const status = useWatch<FormValues>({
    name: 'status',
  }) as GeoEventFormStatus;
  const statusChanged = geoEvent.isActive !== (status === 'active');

  const changes: ChangeMap = {};
  if (statusChanged) {
    changes.status = t('geoEventChangelog.status', {
      prevValue: t(statusToTransKey[geoEvent.isActive ? 'active' : 'inactive']),
      newValue: t(statusToTransKey[status]),
    });
  }

  return changes;
};
